import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./TimeSlotSelector.scss";

const localizer = momentLocalizer(moment);

const CustomToolbar = ({ date, onNavigate }) => {
  const goToToday = () => {
    onNavigate('TODAY');
  };

  return (
    <div>
      <button onClick={goToToday}>Today</button>
      <h2>{moment(date).format("MMMM YYYY")}</h2> {/* Display current month and year */}
    </div>
  );
};


const TimeRangeSelector = ({ duration, selectedDate, removedSelection, slotSelectionHandler }) => {
  const [events, setEvents] = useState([]);

  const [selectedSlot, setSelectedSlot] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date()); // Today's date

  useEffect(() => {
    setCurrentDate(selectedDate);
    onClearBtnHandler();
  }, [selectedDate]);

  useEffect(() => {
    if (removedSelection && removedSelection.start) {
      const updatedEvents = events.filter(
        (event) =>
          event.start !== removedSelection.start && event.end !== removedSelection.end
      );
      setEvents(updatedEvents);
      // slotSelectionHandler(updatedEvents);
    }
  }, [removedSelection]);

  useEffect(() => {
    setEvents((prevEvents) => {
      return prevEvents.map((event) => ({
        ...event,
        error: validateEvents(event.start, event.end),
      }));
    });
  }, [duration]);

  useEffect(()=>{
    slotSelectionHandler(events);
  },[events]);
  

  const handleSelectSlot = ({ start, end }) => {
    setSelectedSlot({ start, end });
    const duplicateIndex = events.findIndex((e) => e.start.toDateString() == start.toDateString() && e.start.getTime() === start.getTime() && e.end.getTime() === end.getTime());
    if (duplicateIndex == -1) {
      const updatedEvents = [...events, { start: start, end: end, error: validateEvents(start, end) }];
      setEvents(updatedEvents);
      // slotSelectionHandler(updatedEvents);
      setSelectedSlot(null);
    }
  };

  const validateEvents = (start, end) => {
    let errorMessage = '';
    const currentDate = new Date();
    const timeDifferenceInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
    const invalidTime = start.toDateString() == currentDate.toDateString() && currentDate.getTime() > start.getTime();

    if (timeDifferenceInMinutes < Number(duration)) {
      errorMessage = "Selected slot is less then selected call duration.";
    } else if (invalidTime) {
      errorMessage = "Selected time is less then current time."
    }

    return errorMessage;
  }

  const displayEvents = React.useMemo(() => {
    return selectedSlot
      ? [...events, { start: selectedSlot.start, end: selectedSlot.end, color: 'lightgreen' }]
      : events;
  }, [events, selectedSlot]);

  const onClearBtnHandler = () => {
    setEvents([]);
    // slotSelectionHandler([]);
  }


  return (
    <div className="timeselector__mainwrap">
      {events?.length > 0 &&
        <div className="clear-user-selection-btn">
          <span onClick={() => onClearBtnHandler()}>Clear</span>
        </div>
      }
      <div className="timeselector__wrap">
        <Calendar
          localizer={localizer}
          events={displayEvents}
          selectable
          onSelectSlot={handleSelectSlot}
          startAccessor="start"
          endAccessor="end"
          defaultView="day" // Set the default view to 'day'
          date={currentDate} // Set the current date
          min={moment(currentDate).startOf('day').toDate()}
          max={moment(currentDate).endOf('day').toDate()}
          step={15}
          timeslots={Number(duration) / 15}
          components={{
            toolbar: CustomToolbar,
          }}
        />
      </div>
    </div>
  );
};

export default TimeRangeSelector;